import React from "react";
import {Box, Checkbox, Chip, FormControl, IconButton, InputLabel, ListItemText, MenuItem, Select} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface MultiSelectFilterProps {
    label: string;
    value: string;
    setFilter: (value: string) => void;
    removeFilter: () => void;
    options: { label: string; value: string }[];
    isMobile: boolean;
}

const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({
                                                                 label,
                                                                 value,
                                                                 setFilter,
                                                                 removeFilter,
                                                                 options,
                                                                 isMobile
                                                             }) => {
    const selectValue = value === '' ? [] : value.split(',');

    return <FormControl variant="standard" sx={{minWidth: 180, mt: 1}} fullWidth={isMobile}>
        <InputLabel>{label}</InputLabel>
        <Select
            multiple
            displayEmpty
            value={selectValue}
            onChange={(e) => {
                setFilter((e.target.value as string[]).join(','));
            }}
            renderValue={(selected) => {
                return (
                    <Box sx={{display: 'flex', gap: 0.5, overflowX: 'auto'}}>
                        {selected.map((value) => (
                            <Chip key={value} label={options.find(option => option.value === value)?.label}/>
                        ))}
                    </Box>
                );
            }}
            endAdornment={
                selectValue.length ? (
                    <IconButton
                        onClick={removeFilter}
                        size="small"
                        sx={{marginRight: 2}}
                    >
                        <ClearIcon/>
                    </IconButton>
                ) : null
            }
        >
            {options.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    <Checkbox checked={selectValue.includes(option.value)}/>
                    <ListItemText primary={option.label}/>
                </MenuItem>
            ))}
        </Select>
    </FormControl>

};

export default MultiSelectFilter;